import axios from 'axios'
import qs from 'qs'
// 生成一个 axios 实例
const instance = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  // baseURL: 'https://www.bytapp.com/byt-api/', // api 的 base_url
  timeout: 10000 // 请求 超时配置
})

console.log(process.env.BASE_API);

export default instance



// WEBPACK FOOTER //
// ./src/api/axios.js